export interface ApiResponse<T> {
  ok: boolean;
  data: T | null;
  error?: any;
}

export async function apiClient<T>(
  input: RequestInfo,
  init?: RequestInit
): Promise<ApiResponse<T>> {
  try {
    const response = await fetch(input, {
      ...init,
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...(init?.headers || {}),
      },
    });

    const text = await response.text();
    const data = text ? JSON.parse(text) : null;

    if (!response.ok) {
      return { ok: false, data: null, error: data || response.statusText };
    }

    return { ok: true, data };
  } catch (error) {
    return { ok: false, data: null, error };
  }
} 